import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EditPartDialogComponent } from './edit-part-dialog/edit-part-dialog.component';
import { take } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { HlCurrencyPipe } from '../../../../shared/pipes/hl-currency.pipe';
import { AsyncPipe } from '@angular/common';
import { PartsSearchComponent } from './parts-search/parts-search.component';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

export interface TemplatePart {
  name: string;
  price: number;
  quantity: number;
  retail_product_id: number | null;
}

@Component({
    selector: 'app-parts-list',
    templateUrl: './parts-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PartsListComponent,
            multi: true
        }
    ],
    standalone: true,
    imports: [MatIconButton, MatIcon, PartsSearchComponent, AsyncPipe, HlCurrencyPipe]
})
export class PartsListComponent implements ControlValueAccessor {
  parts: (TemplatePart & { uuid: string })[] = [];

  onChange: any = () => null;
  onTouched: any = () => null;
  disabled = false;

  constructor(
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  private get partsList(): TemplatePart[] {
    return this.parts.map(({ uuid, ...part }) => part);
  }

  addPart(part: TemplatePart) {
    const uuid = window.crypto.randomUUID();
    this.parts.push({ ...part, uuid });
    this.onChange(this.partsList);
  }

  removePart(index: number) {
    const part = this.parts[index];
    this.parts.splice(index, 1);
    this.onChange(this.partsList);
  }

  editPart(index: number) {
    const part = this.parts[index];
    this.dialog
      .open<EditPartDialogComponent, TemplatePart>(EditPartDialogComponent, {
        data: part
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((editedPart) => {
        if (editedPart) {
          // const uuid = window.crypto.randomUUID();
          this.parts[index] = {
            ...part,
            ...editedPart,
            price: editedPart.price * 100
          };
          this.cdr.detectChanges();
          this.onChange(this.parts);
        }
      });
  }

  writeValue(obj: any): void {
    if (obj && Array.isArray(obj)) {
      obj = obj.map((part) => ({ ...part, uuid: window.crypto.randomUUID() }));
    }
    this.parts = obj ?? [];
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
